export function toLowerTraincaseInverse(word: string) {
	return word
		.split("_")
		.map((w) => w[0]?.toUpperCase() + w.slice(1))
		.join(" ")
}
